"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildDirectiveType = void 0;
var BuildDirectiveType;
(function (BuildDirectiveType) {
    BuildDirectiveType[BuildDirectiveType["SCRIPT"] = 0] = "SCRIPT";
    BuildDirectiveType[BuildDirectiveType["SHELLCODE"] = 1] = "SHELLCODE";
})(BuildDirectiveType || (exports.BuildDirectiveType = BuildDirectiveType = {}));
